<span class="scroll-top-button" aria-label="ページ上部へ戻る" (click)="scrollToTop()"  [@scroll]="displayButton"></span>
